
export default {
  props: {
    contentData: {
      type: Object,
      default: () => {},
    },
    questionFormData: {
      type: [Object, null],
      default: null,
    },
    askQuestionData: {
      type: [Object, null],
      default: null,
    },
    shipReturnData: {
      type: [Object, null],
      default: null,
    },
  },
  data() {
    const tabsOptions = {
      // description: { value: "description", label: this.$t("description") }, // hide for now. Maybe will show later
      ship_return: { value: "ship_return", label: this.$t("shipReturn") },
      ask_question: { value: "ask_question", label: this.$t("askAQuestion") },
    };
    return {
      activeTab: tabsOptions.ask_question.value,
      tabsOptions,
    };
  },
};
